<script setup lang="ts">
import { Plus, UserRound } from 'lucide-vue-next';
import { useFamily } from '@/composables/useFamily';
import { useNavigation } from '@/composables/useNavigation';

const { activeChildren, family, selectChild } = useFamily();
const { navigate } = useNavigation();
</script>

<template>
  <section class="mx-auto max-w-7xl px-4 py-6 pb-28 sm:px-6 md:pb-10">
    <div class="flex flex-wrap items-center justify-between gap-4">
      <div>
        <p class="text-sm font-black uppercase tracking-[0.16em] text-heart-leaf">{{ family.name }}</p>
        <h1 class="mt-2 text-4xl font-black text-heart-berry md:text-6xl">Wer moechte heute ins Herzhaus?</h1>
      </div>
      <button
        class="focus-ring inline-flex min-h-14 items-center gap-2 rounded-full bg-white px-5 font-black text-heart-ink shadow-sm"
        type="button"
        @click="navigate('parent-settings')"
      >
        <Plus class="h-6 w-6 text-heart-coral" aria-hidden="true" />
        Kind anlegen
      </button>
    </div>

    <div class="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      <button
        v-for="child in activeChildren"
        :key="child.id"
        class="focus-ring min-h-64 rounded-[34px] bg-white p-6 text-left shadow-soft transition hover:-translate-y-1 active:scale-[0.98]"
        type="button"
        :aria-label="`${child.firstName} auswaehlen`"
        @click="selectChild(child); navigate('child-home')"
      >
        <span class="grid h-24 w-24 place-items-center overflow-hidden rounded-[30px] text-white" :style="{ backgroundColor: child.favoriteColor }">
          <img v-if="child.profileImageUrl" class="h-full w-full object-cover" :src="child.profileImageUrl" alt="" />
          <UserRound v-else class="h-14 w-14" aria-hidden="true" />
        </span>
        <span class="mt-6 block text-4xl font-black text-heart-ink">{{ child.firstName }}</span>
        <span class="mt-2 block text-lg font-bold text-slate-500">Eigenes Freundeshaus</span>
      </button>
    </div>
    <p v-if="activeChildren.length === 0" class="mt-8 rounded-[28px] bg-white p-6 text-xl font-black text-heart-ink shadow-soft">
      Lege im Elternbereich ein aktives Kinderprofil an.
    </p>
  </section>
</template>
